/*
 * @Description: 特殊付款申请（无PO）
 */
import { RootObject } from '@/model/rootObject'
import https, { downloadExcel } from '@/utils/https'
import { ContentType, Method } from 'axios-mapper'
import {
  CreateNoPORequestModel, NoPORequestIdListModel,
  NoPORequestListParamModel,
  NoPORequestModel, NoPORequestPageModel, NoPORequestPageParamModel, NoPORequestSetPaymentDateModel,
  NoPOSelectedResultModel,
  NoPOSetPurposeParamModel,
  UpdateNoPORequestModel

} from '@/model/application-form/specialPaymentRequestNoPO'
import networkConfig from '@/config/default/net.config'

const baseUrl = '/base/payment/withoutPo'
export const excelNoPOFileUpload = () => {
  return networkConfig.host + baseUrl + '/import/excel'
}
export const createNoPORequest = (params: CreateNoPORequestModel) => {
  return https().request<RootObject<number>>(baseUrl + '/add', Method.POST, params, ContentType.json)
}

export const updateNoPORequest = (params: UpdateNoPORequestModel) => {
  return https().request<RootObject<number>>(baseUrl + '/update', Method.POST, params, ContentType.json)
}

export const getNoPORequestById = (id: number) => {
  return https()
    .request<RootObject<NoPORequestModel>>(baseUrl + '/get/' + id, Method.GET, undefined, ContentType.json)
}

export const getNoPORequestPageList = (params: NoPORequestPageParamModel) => {
  return https().request<RootObject<NoPORequestPageModel>>(baseUrl + '/list', Method.POST, params, ContentType.json)
}

export const getNoPORequestPageListByUser = (params: NoPORequestPageParamModel) => {
  return https().request<RootObject<NoPORequestPageModel>>(baseUrl + '/listByUser', Method.POST, params, ContentType.json)
}

export const getNoPORequestAllList = (params: NoPORequestListParamModel) => {
  return https().request<RootObject<NoPORequestModel[]>>(baseUrl + '/list/all', Method.POST, params, ContentType.json)
}

export const setNoPORequestPaymentDate = (params: NoPORequestSetPaymentDateModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/set/paymentDate', Method.POST, params, ContentType.json)
}

export const generateNoPOApprovalForms = (params: NoPORequestIdListModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/generate/approvalForms', Method.POST, params, ContentType.json)
}

export const getNoPORequestByIds = (params: NoPORequestIdListModel) => {
  return https()
    .request<RootObject<NoPOSelectedResultModel[]>>(baseUrl + '/get/selectedApprovalForms', Method.POST, params, ContentType.json)
}
export const cancelNoPOApplication = (params: NoPORequestIdListModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/cancel/application', Method.POST, params, ContentType.json)
}

export const setNoPOSetPurpose = (params: NoPOSetPurposeParamModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/set/purpose', Method.POST, params, ContentType.json)
}

export const exportNoPOTemplate = () => {
  return downloadExcel(baseUrl + '/export/excelTemplate', Method.GET, undefined)
}
